import { ScholarshipForm } from '@/components/forms/ScholarshipForm'

export function ScholarshipPage() {
  return (
    <div className="py-24">
      <div className="container-narrow">
        <div className="mb-12 max-w-2xl">
          <span className="eyebrow">College Placements &amp; Pro Invites</span>
          <h1 className="mt-3 font-display text-display-2 uppercase">Cosmos F.C. Scholarship.</h1>
          <p className="mt-4 text-muted-foreground">
            Financial-aid pathway for eligible Cosmos F.C. players. Complete the application below — the scholarship committee reviews all submissions within 3-4 weeks.
          </p>
        </div>
        <ScholarshipForm />
      </div>
    </div>
  )
}
